// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"800e16e9","170":"624c18c1","488":"d4c5138c"}[chunkId] + ".chunk.js";
};